module.exports = __webpack_public_path__ + "img/dlna.de153eb8.svg";